"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _tracking = require("FileManagerCore/actions/tracking");

var _ImageOptimizationSettings = require("../../actions/ImageOptimizationSettings");

var _ImageOptimizationSettings2 = require("../../selectors/ImageOptimizationSettings");

var ImageOptimizationSettings = _interopRequireWildcard(require("../../enums/ImageOptimizationSettings"));

function getI18nKey(suffix) {
  return "FileManagerLib.imageOptimizationSettings." + suffix;
}

var imageOptimizationSettingsValues = Object.keys(ImageOptimizationSettings).map(function (setting) {
  return ImageOptimizationSettings[setting];
});

var ImageOptimizationControl = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ImageOptimizationControl, _PureComponent);

  function ImageOptimizationControl() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ImageOptimizationControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ImageOptimizationControl)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.options = imageOptimizationSettingsValues.map(function (value) {
      return {
        text: _I18n.default.text(getI18nKey("text." + value)),
        help: _I18n.default.text(getI18nKey("help." + value)),
        value: value
      };
    });
    return _this;
  }

  (0, _createClass2.default)(ImageOptimizationControl, [{
    key: "renderLabel",
    value: function renderLabel() {
      return _react.default.createElement("span", {
        className: "m-right-2"
      }, _react.default.createElement(_UIHelpIcon.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('description')
        })
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('label')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSelectImageOptimizationSetting = _this$props.onSelectImageOptimizationSetting,
          imageOptimizationSetting = _this$props.imageOptimizationSetting;
      return _react.default.createElement("div", {
        className: "m-top-2"
      }, this.renderLabel(), _react.default.createElement(_UISelect.default, {
        buttonUse: "link",
        menuWidth: "auto",
        onChange: onSelectImageOptimizationSetting,
        value: imageOptimizationSetting,
        options: this.options
      }));
    }
  }]);
  return ImageOptimizationControl;
}(_react.PureComponent);

ImageOptimizationControl.propTypes = {
  onSelectImageOptimizationSetting: _propTypes.default.func.isRequired,
  imageOptimizationSetting: _propTypes.default.oneOf(imageOptimizationSettingsValues).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    imageOptimizationSetting: (0, _ImageOptimizationSettings2.getImageOptimizationSetting)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectImageOptimizationSetting: function onSelectImageOptimizationSetting(_ref) {
      var value = _ref.target.value;
      dispatch((0, _tracking.trackInteraction)('fileManagerImageOptimization', 'Change image optimization setting', {
        setting: value
      }));
      dispatch((0, _ImageOptimizationSettings.selectImageOptimizationSetting)(value));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImageOptimizationControl);

exports.default = _default;
module.exports = exports.default;